import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=e5a18344&scoped=true"
import script from "./privilege.vue?vue&type=script&lang=js"
export * from "./privilege.vue?vue&type=script&lang=js"
import style0 from "./privilege.vue?vue&type=style&index=0&id=e5a18344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a18344",
  null
  
)

export default component.exports